export default {"src":"/_next/static/media/paragliding.24502f35.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};